/**
 * El código de socio: corto, en mayúsculas y sin caracteres que se confundan al
 * dictarlo (ni O ni 0, ni I ni 1, ni L). Sale del nombre de la cuenta y, si hace
 * falta, se completa al azar. **No cambia nunca**: está en enlaces que ya se han
 * compartido.
 */
export const ALFABETO_DE_CODIGO = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789'
export const LARGO_MINIMO_DE_CODIGO = 4
export const LARGO_MAXIMO_DE_CODIGO = 12
export const RE_CODIGO = /^[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{4,12}$/

export const normalizarCodigo = (valor: unknown): string => (typeof valor === 'string' ? valor.trim().toUpperCase() : '')

export const esCodigoDeSocio = (valor: unknown): boolean => RE_CODIGO.test(normalizarCodigo(valor))

const sinAcentos = (texto: string): string => texto.normalize('NFD').replace(/[̀-ͯ]/g, '')

/**
 * Las letras fijas que salen del nombre: «Monstruo Creativo» → «MNSTRCRT». Se quitan
 * las vocales y lo que no está en el alfabeto; si queda poco, se usan las vocales
 * también. Puro: el azar lo pone quien llama.
 */
export const letrasDelNombre = (nombre: string, maximo = 8): string => {
  const limpio = sinAcentos(nombre).toUpperCase().replace(/[^A-Z0-9]/g, '')
  const admitidas = [...limpio].filter((c) => ALFABETO_DE_CODIGO.includes(c)).join('')
  const consonantes = admitidas.replace(/[AEIOU]/g, '')
  const base = consonantes.length >= LARGO_MINIMO_DE_CODIGO ? consonantes : admitidas
  return base.slice(0, maximo)
}

/**
 * Un código a partir del nombre y de una fuente de azar (`azar()` da un número en
 * [0, 1)). `fijas` dice cuántas letras del nombre se conservan: cada reintento por
 * choque conserva menos y pone más azar, hasta ser todo azar.
 */
export const generarCodigo = (nombre: string, azar: () => number, fijas = 8): string => {
  const delNombre = letrasDelNombre(nombre, Math.max(0, fijas))
  const largo = Math.max(LARGO_MINIMO_DE_CODIGO + 2, Math.min(LARGO_MAXIMO_DE_CODIGO, delNombre.length + 2))
  let codigo = delNombre
  while (codigo.length < largo) codigo += ALFABETO_DE_CODIGO[Math.floor(azar() * ALFABETO_DE_CODIGO.length) % ALFABETO_DE_CODIGO.length]
  return codigo.slice(0, LARGO_MAXIMO_DE_CODIGO)
}
